// extracted by mini-css-extract-plugin
export default {"affair":"Affair_affair__9M-ZP","name":"Affair_name__VaxQv","closeButton":"Affair_closeButton__+0HbC"};